"use client";

import { useEffect } from "react";
import { startInterestBeaconWithConsentWatch } from "@/lib/interest-beacon";

/**
 * L3 (leren op interesse, 21-09-2026): tijd op pagina (heartbeat elke 15s
 * tot 10 min), scrolldiepte (25/50/75/100) en sessiebrede klikdiepte voor
 * één deal-pagina. Achter NEXT_PUBLIC_INTEREST_BEACON_ENABLED (standaard
 * uit) + analytics-consent (zie interest-beacon.js) — no-op zolang één van
 * beide ontbreekt.
 *
 * Zelfde plaatsingspatroon als RecordDealView/RecordDealClickFromLanding:
 * los, `dynamic()`-geïmporteerd component onder de fold, geen render-
 * impact op de rest van de pagina. `startInterestBeaconWithConsentWatch`
 * registreert pas listeners nadat de browser idle is (requestIdleCallback,
 * zodat het de eerste paint niet vertraagt) en luistert daarna zelf op het
 * consent-event, zodat een bezoeker die de cookiebanner pas ná mount
 * accepteert alsnog wordt meegeteld voor DEZE paginaweergave (BLOK-1,
 * Opus r2 / Codex r3).
 *
 * De cleanup hieronder (unmount = App-Router-navigatie weg van de deal, of
 * een andere dealId) stuurt via de wrapper nog precies één laatste
 * vertrek-heartbeat, net als tab sluiten (post-review #1438, 23-09); was
 * het vertrek al via visibilitychange/pagehide verstuurd, dan niets extra.
 */
export default function RecordDealInterest({ dealId }) {
  useEffect(() => {
    if (dealId == null) return undefined;

    let cleanup;
    const start = () => {
      cleanup = startInterestBeaconWithConsentWatch(dealId);
    };

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const handle = window.requestIdleCallback(start);
      return () => {
        window.cancelIdleCallback?.(handle);
        cleanup?.();
      };
    }

    const timer = setTimeout(start, 0);
    return () => {
      clearTimeout(timer);
      cleanup?.();
    };
  }, [dealId]);

  return null;
}
